import { IMFile } from '@wui/im'

import { useLocalization } from '@/shared/composables/localization'
import { useFetchApi, Request, FetchApi } from '@/shared/utils/fetch'
import { getFullURL } from '@/shared/utils/url'

const writeBinaryFile = async (fileSrc: string, chosenPath: string, options?: Request) => {
  const useFetch = useFetchApi() as FetchApi
  const { t } = useLocalization()
  try {
    const response = await useFetch.get<Response>(fileSrc, {
      ...(options || {}),
      responseType: 3,
    })

    const buffer = new Uint8Array(await response.data.arrayBuffer())

    const { writeFile } = await import('@tauri-apps/plugin-fs')
    await writeFile(chosenPath, buffer)
    return true
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : t('common.unknownError')
    throw new Error(errorMessage)
  }
}

export const downloadFileTauri = async (file: IMFile, pathName?: string): Promise<boolean | null> => {
  const { save } = await import('@tauri-apps/plugin-dialog')
  const { downloadDir, join } = await import('@tauri-apps/api/path')
  const defaultPath = await join(await downloadDir(), file.filename)
  const chosenPath = await save({ defaultPath })
  if (chosenPath !== null) {
    const url = pathName ? `${pathName}${file.filecookie}` : file.filecookie
    const fileSrc = getFullURL(url)
    await writeBinaryFile(fileSrc, chosenPath)
    const { revealItemInDir } = await import('@tauri-apps/plugin-opener')
    revealItemInDir(chosenPath).catch(console.error)
    return true
  }
  return null
}
